import axios from 'axios';
import { getDomainId } from '../../../../utils/utils';
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../../constants";

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })

const getAllDatesInRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dates = [];

  while (start <= end) {
    dates.push(new Date(start));
    start.setDate(start.getDate() + 1);
  }
  return dates;
};

const getDefaultDateRange = () => {
  const today = new Date();
  const prior = new Date();
  prior.setDate(today.getDate() - 30);
  return {
    start_date: prior.toISOString(),
    end_date: today.toISOString(),
  };
};

const GradientLineChartData1 = async (start, end) => {
  try {
    const domainId = await getDomainId();

    const range = {
      start_date: start || getDefaultDateRange().start_date,
      end_date: end || getDefaultDateRange().end_date,
    };

    const res = await axios.get(`${LAMBDA_BASE_URL}/date-range-user-count`, {
      params: {
        start_date: range.start_date,
        end_date: range.end_date,
      },
      headers: {
        'DOMAIN-TOKEN': domainId,
      },
    });

    const result = res.data.result;
    const countMap = {};
    result.forEach((item) => {
      const dateStr = formatDate(item.created_date);
      countMap[dateStr] = item.count;
    });

    const fullDateList = getAllDatesInRange(range.start_date, range.end_date);
    const labels = fullDateList.map((date) => formatDate(date));
    const values = fullDateList.map((date) => {
      const key = formatDate(date);
      return countMap[key] || 0;
    });

    return {
      labels,
      datasets: [
        {
          label: "Total",
          color: "teal",
          data: values,
        },
      ],
    };
  } catch (error) {
    console.error("Failed to fetch chart data:", error);
    return {
      labels: [],
      datasets: [],
    };
  }
};

export default GradientLineChartData1;
